// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const ViduLogo2 = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 68 70" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.02" filter="url(#filter0_i_32441_1838)">
      <path
        d="M72.9816 0.896442C62.6499 -2.6061 53.7643 4.824 51.6929 11.6242C51.6929 11.6242 44.2382 36.1267 41.0611 46.3526C39.5452 51.2275 35.7878 59.2106 28.7132 59.2106C22.9495 59.2106 19.9876 53.6752 18.7368 50.3775L10.1463 26.9351C9.15071 24.4669 10.1914 19.5408 14.1839 18.066C18.4467 16.4991 21.1884 20.1502 21.8989 22.0858L32.6007 50.1471C35.1523 46.7828 36.7734 41.3088 37.8291 37.4324L30.7996 18.5525C27.4674 9.73984 18.6618 5.73548 10.4916 8.813C3.87733 11.3068 -2.48674 19.848 0.975472 30.581L9.84115 53.921C11.187 57.4594 16.5054 69.0116 28.5231 69.0116C42.9473 69.0116 48.3608 56.425 51.3627 46.4755C52.8637 41.4982 61.099 14.5891 61.099 14.5891C62.2947 10.5694 67.1578 9.41211 70.1948 10.426C72.3362 11.1378 76.2086 14.1641 74.9578 18.8546C74.7227 19.7098 68.1585 41.36 65.7369 47.9452C64.4711 51.3811 61.2641 58.8419 53.9644 57.8025C51.738 62.8463 49.8918 65.7753 47.095 68.4073C56.2008 72.8214 69.4743 68.3766 75.0629 51.0944C77.1392 44.6679 84.4289 21.4969 84.4289 21.4969C86.5502 14.3792 82.7678 4.21464 72.9816 0.896442Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <filter
        height="70"
        id="filter0_i_32441_1838"
        width="85"
        x="0"
        y="0"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood result="BackgroundImageFix" floodOpacity="0" />
        <feBlend result="shape" in="SourceGraphic" in2="BackgroundImageFix" />
        <feBlend result="effect1_innerShadow_32441_1838" in2="shape" />
        <feGaussianBlur stdDeviation="1.17145" />
      </filter>
    </defs>
  </svg>
);
